import { css } from "styled-components";
import tw from "twin.macro";

export const DefaultInputStyles = () => css`
	${tw`tw-flex-grow`}
`;
